import React from "react";
import classes from "./logo.module.css";

const Logo = () => {
	return <h1 className={classes.Logo}>My Weather</h1>;
};

export default Logo;
